import { render, staticRenderFns } from "./model.vue?vue&type=template&id=013ab1a0&scoped=true"
import script from "./model.vue?vue&type=script&lang=js"
export * from "./model.vue?vue&type=script&lang=js"
import style0 from "./model.vue?vue&type=style&index=0&id=013ab1a0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013ab1a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013ab1a0')) {
      api.createRecord('013ab1a0', component.options)
    } else {
      api.reload('013ab1a0', component.options)
    }
    module.hot.accept("./model.vue?vue&type=template&id=013ab1a0&scoped=true", function () {
      api.rerender('013ab1a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/createQuotation/model.vue"
export default component.exports